import React, {useEffect, useState} from 'react'
import styles from "../Corpus/corpus.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import "../../App.css"
import UnitStyles from './MilUnit.module.css'
export default function MillUnitCorpus({millUnits, corpusNumber, changeCorpus, deleteMilUnit}) {
    const [filteredUnits, setFilteredUnits] = useState([])
    useEffect(() => {
        setFilteredUnits(millUnits.filter(el => el.unit_corpus === corpusNumber))
    }, [millUnits])
  return (
      <div className={UnitStyles["units-main-div"]}>
          <div className={UnitStyles["unit-list"]}>
              <ol className='border-t border-black/40'>
                  <li className={styles["corpus-list-item"]}>
                      <p className='per3 start'>Զորամաս</p>
                      <p className='per3 end'>Ղեկավարման կոճակներ</p>
                  </li>
                  {filteredUnits?.map((el, index) => {
                      return <li key={index} className={styles["corpus-list-item"]}>
                              <p className='per3 start'>{el?.unit_number + " " + el.unit_name}  ({el?.unit_close_number})</p>
                              <div className='per3 end'>
                                  <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => changeCorpus(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                  <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => deleteMilUnit(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                              </div>
                          </li>
                  })}
                  
              </ol>
          </div>
      </div>
    )
}
